import { createAction } from "redux-act";

export const request = createAction("Change language request");
export const changeLanguage = createAction("Change language");